export default {"src":"/_next/static/media/confetti.03e452e9.svg","height":900,"width":1440,"blurWidth":0,"blurHeight":0};